
import { getEnv } from './index.js' ;
export const setAliArms = () => {
    if (window.ActiveXObject || 'ActiveXObject' in window || getEnv() !== 'pro'){
        return;
    }
    const BrowerLogger = require('alife-logger');
    /* eslint-disable */
    const __bl = BrowerLogger.singleton({
        pid: 'a644wg37bd@2b0c63dc1577623',
        imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?', // 设定日志上传地址
        enableSPA: true,
        // disableHook:true,
        sendResource: true,
        urlHelper: [
            /\/$/
        ],
        apiHelper: [
            {rule: /\/([a-z\-_]+)?\d{2,}/g, target: '/**'},
        ],
        ignore: {
            ignoreErrors: [
                /^Script error\.?$/,
                /^Request failed with status code 403\.?$/,
                /^ResizeObserver loop limit exceeded\.?$/,
                /^Network Error\.?$/,
                /^Loading chunk?/
            ]
        },
        sample:10
    });
};
